import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  TableBody,
  Drawer,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import FormulationPreACAAging from './FormulationPreACAAging';

const StatusMoods = [
  'NOT OUR PATIENT', 'ALREADY HAS AN APPOINTMENT', 'OPEN', 'INSURANCE CHANGED', 'OTHER PCP', 'PENDING', 'REFUSED'
]

const CodingDetails = ({ modificar = {}, onSave}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [openCommentDialog, setOpenCommentDialog] = useState(false);
  const [openReferralForm, setOpenReferralForm] = useState(false);

  const [form, setForm] = useState({
    MemberID: modificar.MemberID,
    MemberFullName: modificar.MemberFullName,
    DOB: modificar.DOB,
    Age: modificar.Age,
    MemberPlan: modificar.MemberPlan,
    MemberPlanEffectiveDate: modificar.MemberPlanEffectiveDate,
    MemberEmail: modificar.MemberEmail,
    MemberPhoneNumber: modificar.MemberPhoneNumber, 
    CallLog: modificar.CallLog,
    Comments: modificar.Comments,
    OfficeLocation: modificar.OfficeLocation,
    Update: modificar.Update,
    AddressLine1: modificar.AddressLine1,
    CityName: modificar.CityName,
    ZipCode: modificar.ZipCode,
    Country: modificar.Country,
    PCPFullName: modificar.PCPFullName,
    Type: modificar.Type
  });

  const SaveNewSystemicBilling  = (newSystemicBilling) => {
    setForm((newSystemicBilling));
    onSave(newSystemicBilling);
  }

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">ACA Againg 62-65</Typography>
        {!isEditing && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={() => setOpenReferralForm(true)}>Edit</Button>
        )}
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item width="100%"><Typography><strong>Member ID:</strong> {form.MemberID}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Full Name:</strong> {modificar.MemberFullName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>DOB:</strong> {modificar.DOB}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Plan Effective Date:</strong> {modificar.MemberPlanEffectiveDate}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Email:</strong> {modificar.MemberEmail}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Member Phone Number:</strong> {form.MemberPhoneNumber}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Address Line 1:</strong> {form.AddressLine1}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>City Name:</strong> {form.CityName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Zip Code:</strong> {form.ZipCode}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Country:</strong> {form.Country}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>PCP Full Name:</strong> {form.PCPFullName}</Typography></Grid>
              <Grid item width="100%"><Typography><strong>Call Log:</strong> {form.CallLog}</Typography></Grid>
            </Grid>
        </Grid>
      </Paper>
            
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item width="100%"><Typography><strong>Office Location:</strong> {modificar.OfficeLocation}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Update:</strong> {modificar.Update}</Typography></Grid>
          <Grid item width="100%"><Typography><strong>Type:</strong> {modificar.Type}</Typography></Grid>
        </Grid>
      </Paper>

      {/* Add Comment Dialog */}
      <Drawer anchor="right" open={openReferralForm} onClose={() => setOpenReferralForm(false)}>
          <Box width={650} p={3}>
              <FormulationPreACAAging
                  modificar={ modificar?? [] }
                  open={openReferralForm}
                  onClose={() => setOpenReferralForm(false)}
                  onSave={(newReferral) => {
                      SaveNewSystemicBilling(newReferral);
                      setOpenReferralForm(false);
                  }}
              />
          </Box>
      </Drawer>
    </Container>
  );
};

export default CodingDetails;
